import { getElRect } from "./getElRect.fn";

export function getElStartYPos(element: HTMLDivElement): number {
  if (element.id === "test") {
    console.log(getElRect(element).y, window.scrollY, window.innerHeight);
  }
  return getElRect(element).y + window.scrollY - window.innerHeight;
}
